"use strict";
/**
 * Social API Types
 *
 * Based on actual backend Lambda function analysis:
 * - artist-following.ts (FollowArtist, UnfollowArtist)
 * - pattern-favorites.ts (AddFavorite, RemoveFavorite)
 * - get-user-relations.ts (GetUserRelations)
 * - get-user-followers-paginated.ts, get-user-following-paginated.ts
 *
 * Derivation note: All social response types remain standalone because they are
 * assembled from multiple queries (user profiles, follow records, favorite records,
 * notifications, settings) rather than mapping directly from a single DynamoDB record.
 * - FollowArtistSuccessResponse / UnfollowArtistSuccessResponse: handler constructs
 *   { message, artist_id, artist_screen_name } from path params + lookup, not from FollowRecord fields.
 * - AddFavoriteSuccessResponse / RemoveFavoriteSuccessResponse: handler constructs
 *   { message, pattern_id } — only pattern_id overlaps with FavoriteRecord.
 * - PaginatedFollowersResponse / PaginatedFollowingResponse: items come from getUserProfiles(),
 *   not from FollowRecord fields.
 * - PaginatedFavoritesResponse: items come from enriched PatternDisplayRecords, not FavoriteRecord.
 * - GetUserRelationsResponse: assembled from 6+ separate DynamoDB queries.
 */
Object.defineProperty(exports, "__esModule", { value: true });
